<template>
  <div class="main-container">
    <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />

    <section class="main-content-section">
      <tl-tabs :tabs="tabs">
        <tl-tab>
            <download-form-annexure></download-form-annexure>
        </tl-tab>
        <tl-tab>
            <upload-form-annexure></upload-form-annexure>
        </tl-tab>
      </tl-tabs>
    </section>
  </div>
</template>
<script>
import DownloadFormAnnexure from "./DownloadFormAnnexure.vue";
import UploadFormAnnexure from "./UploadFormAnnexure.vue";
export default {
  name: "Form_16Annexure",
  components: {
    DownloadFormAnnexure,
    UploadFormAnnexure
  },
  data() {
    return {
      breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              },
              {
                name: "Form 16 Annexure",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/form_annexure`
              }
        ],
        tabs:[
            {
                header:'Download Form 16 Annexure'
            },
            {
                header:'Upload Form 16 Annexure'
            }
        ]
    };
  },
  methods: {
    routeToMainStep() {},
    routeToSubStep() {}
  }
};
</script>
<style lang="scss" scoped>
</style>
